enum NotificationType {
  alert = "alert",
  information = "information"
}

export default NotificationType;
